import { navigate } from 'gatsby-link';

export const isObjectEmpty = (obj: Record<string, unknown>): boolean =>
  obj && Object.keys(obj).length === 0 && obj.constructor === Object;

export const logGAPageViewEvent = (pageTitle: string): void => {
  if (window) {
    window.dataLayer?.push({
      event: 'quizPageView',
      quizPageUrl: window.location.pathname,
      quizPageTitle: pageTitle,
    });
  }
};

export const gtagEvent = (id: string, name: string, quantity = 1, price: string, currencyCode: string): void => {
  if (window) {
    window.gtag('event', 'add_to_cart', {
      event_category: 'Ecommerce',
      isPartnerAddToCart: 'False',
      items: [{ id, name, brand: 'LetsGetChecked', quantity, price, currencyCode }],
    });
  }
};

export const navigateToRoute = (route: string): void => {
  const navigation = async (): Promise<void> => {
    await navigate(route);
  };
  navigation().catch(() => {});
};
